import React from 'react';
import cx from 'classnames';
import {
	get,
	head,
	map,
	find,
} from 'lodash';

import { getPathByRoute } from 'App.js';
import routeKeys from 'CustomerRouteKeys.js';
import { useTransitAccountIdContext } from 'context/TransitAccountIdContext.js';
import { DropdownCard } from 'components/icons/CardBrands.js';

import Dropdown, { DropdownItem } from "components/Dropdown.js";
import { SmallChevron } from "components/Icon.js";
import { MaskedValues } from 'components/card-icons/GenericIconAndMaskedValue.js';
import { getCreditCardType } from 'components/card-icons/util';

import * as charlieDropdown from './CharlieDropdown.module.css';
import * as style from './CardSelector.module.css';
import { useAllTransitAccounts } from 'components/data/transit-account/TransitAccount';

/**
 * Shows a dropdown for the cards on the account, powered by
 * the HeadlessUI Menu component
 */
const CardSelector = () => {
	const transit_account_id = useTransitAccountIdContext();

	const { transitAccounts, loading: transitAccountsLoading } = useAllTransitAccounts({});

	if (!transit_account_id || transitAccountsLoading) {
		return null;
	}


	const cards = map(transitAccounts, transitAccount => {
		const token = head(transitAccount.tokens);

		// sometimes TAs dont have tokens in that case they are Ghost Cards
		if (!token) {
			return null;
		};

		const tokenInfo = get(token, 'tokenInfo', {});

		return {
			id: token.tokenId,
			label: <MaskedValues {...{
				showName: true,
				nickname: tokenInfo.tokenNickname,
				maskedPan: tokenInfo?.maskedPan,
				creditCardType: getCreditCardType(tokenInfo),
				serialNumber: tokenInfo?.serialNumber,
				tokenType: tokenInfo.tokenType,
			}} />,
			action: getPathByRoute(routeKeys.AccountCardOverview, { transit_account_id: transitAccount.subsystemAccountReference }),
			subsystemAccountReference: transitAccount.subsystemAccountReference,
			type: tokenInfo.tokenType,
		};
	}).filter(x => x);

	const selectedCard = find(cards, option => option.subsystemAccountReference === transit_account_id);

	if (!selectedCard) {
		return null;
	}

	return (
		<Dropdown
			id={'mobileCardSelector'}
			overrideClass={cx(charlieDropdown.container, style.container)}
			overrideButtonClass={cx(charlieDropdown.toggle, style.toggle)}
			overrideOptionsClass={charlieDropdown.options}
			label={
				<>
					<span className={cx(charlieDropdown.iconCard, charlieDropdown.toggleIcon)}>
						<DropdownCard type={selectedCard.type} />
					</span>
					<SmallChevron overrideClass={charlieDropdown.toggleArrow} aria-hidden={true} />
				</>
			}
		>
			{cards?.map((card) => (
				<DropdownItem overrideClass={charlieDropdown.option} to={card.action} key={`link-${card.id}`} itemKey={`link-${card.id}`}>
					{card.label}

					<span className={charlieDropdown.iconCard}>
						<DropdownCard type={card.type} />
					</span>
				</DropdownItem>
			))}
		</Dropdown>
	);
};


export default CardSelector;
